import { Container } from "react-bootstrap";
import MainMenu from "../../../modules/public/mainMenu/mainMenu";
import { useQuery } from "@tanstack/react-query";
import { getAuthMethod } from "../../../modules/helper";
import useFilterParams from "../../../hooks/useFilterParams";
import Swal from "sweetalert2";
import DigikalaCoworkerCreditFilters from "./DigikalaCoworkerCreditFilters";
import DigikalaCoworkerCreditTable from "./DigikalaCoworkerCreditTable";
import PaginateCard from "../../../components/PaginateCard";

export default function DigikalaCoworkerCredit() {
  const filters = useFilterParams({
    page: 1,
    items: 10,
  });

  const { data, refetch, isFetching } = useQuery({
    queryKey: ["DigikalaCoworkerCredit"],
    queryFn: () =>
      getAuthMethod(
        "/v1/digikala/coworker/credit",
        filters.getAllParams()
      ).then(res => {
        if (res && res.status === 200) {
          return res.data.data;
        }

        Swal.fire({
          title: "دریافت اطلاعات با خطا مواجه شد",
          confirmButtonText: "متوجه شدم",
          icon: "error",
          confirmButtonColor: "red",
        });
        return { count: 0, items: [], credit: 0 };
      }),

    placeholderData: { count: 0, items: [], credit: 0 },
    refetchOnWindowFocus: false,
    gcTime: 0,
  });

  return (
    <MainMenu>
      <Container>
        <DigikalaCoworkerCreditFilters
          filters={filters}
          refetch={refetch}
          isFetching={isFetching}
        />

        <div className="card d-flex flex-row flex-wrap justify-content-center align-items-center mb-4">
          <span style={{ fontSize: 14 }}>اعتبار شما:</span>
          <span className="d-flex ltr me-2 fs-2 text-primary">
            {data.credit.toLocaleString()}
          </span>
          <span className="me-2" style={{ fontSize: 14 }}>
            (ریال)
          </span>
        </div>

        <DigikalaCoworkerCreditTable
          count={data.count}
          items={data.items}
          isFetching={isFetching}
        />

        <PaginateCard
          className="my-4"
          count={data.count}
          numberItems={filters.getParam("items")}
          numberPage={filters.getParam("page")}
          onIndexChoose={page => {
            filters.setParam("page", page);
            refetch();
          }}
        />
      </Container>
    </MainMenu>
  );
}
